export const gbpHandler = {
    pathPattern: '/brands/:brandId/setup/gbp',
    toWeb: ({ brandId }) => ({ path: `/brands/${brandId}/setup/gbp` }),
    // Web lands on setup/gbp; the app recovery screen lives under launch/gbp.
    toNative: ({ brandId }, locationId) => `/${brandId}/${locationId}/launch/gbp`,
    meta: {
        title: 'Google Business Profile recovery',
        description: 'Opens the GBP connection recovery flow for a location.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'locationId', in: 'query', required: false, surface: 'web' },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId' },
            locationId: 'exampleLocationId',
        },
    },
};
//# sourceMappingURL=gbp.js.map